import React from 'react';
import Popup from './Popup';

type SigningSmsInfoPopupProps = {
    onClose: () => void;
};

export const SigningSmsInfoPopup: React.FC<SigningSmsInfoPopupProps> = ({ onClose }) => (
    <Popup onClose={onClose}>
        <div className="security-info-popup">
            <h3 className="H3_21">Код подтверждения при подписании</h3>

            <div className="security-section">
                <h4 className="Subheader_17">Что используется по умолчанию</h4>
                <p>
                    При подписании документов подписанту предлагаются способы получения кода подтверждения:
                </p>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', marginTop: '10px' }}>
                    <li>входящий звонок — код содержится в номере звонящего</li>
                    <li>мессенджер Telegram</li>
                    <li>мессенджер MAX</li>
                </ul>
            </div>

            <div className="security-section">
                <h4 className="Subheader_17">Подключение SMS</h4>
                <p>
                    Дополнительно можно подключить отправку кода по SMS. После подключения опции SMS станет
                    доступен при подписании документов — подписант сможет получить код в сообщении на телефон.
                </p>
                <p>
                    Опция применяется к новым договорам, созданным после её подключения.
                </p>
            </div>
        </div>
    </Popup>
);
